export const debugNameFilterOut = ({ name }: { name: string }) =>
  !name.startsWith('debug') && !name.endsWith('debug');

export enum DraftStatus {
    DRAFT = 'draft',
    SUBMITTED = 'submitted',
  }
  
  export interface Draft {
    component_entity_ref: string;
    system_entity_ref: string;
    data: string;
    changed_by_user_entity_ref?: string;
  }
  
  export interface DraftViewBySystem {
    component_entity_ref: string;
    system_entity_ref: string;
    changed_at: string;
    status: DraftStatus;
    changed_by_user_entity_ref?: string;
    pull_request_url?: string;
  }
  
  export interface DraftViewByComponent {
    component_entity_ref: string;
    system_entity_ref: string;
    changed_at: string;
    status: string;
    data: string;
    changed_by_user_entity_ref?: string;
    pull_request_url?: string;
    pull_request_id?: number;
    merge_commit_id?: string;
  }

  export interface SubmitDraft {
    pullRequestUrl: string;
    pullRequestId: number;
    mergeCommitId?: string;
  }
  